import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoPause = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 30 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.83301 0C7.3801 0 8.86405 0.615022 9.95801 1.70898C11.0518 2.80285 11.6669 4.28611 11.667 5.83301V34.167C11.6669 35.7139 11.0518 37.1971 9.95801 38.291C8.86405 39.385 7.3801 40 5.83301 40C4.28603 39.9999 2.80287 39.3849 1.70898 38.291C0.615099 37.1971 8.64503e-05 35.714 0 34.167V5.83301C8.61653e-05 4.28603 0.615099 2.80287 1.70898 1.70898C2.80287 0.615099 4.28603 8.63861e-05 5.83301 0ZM24.167 0C25.7141 0 27.198 0.615022 28.292 1.70898C29.3857 2.80284 29.9999 4.28616 30 5.83301V34.167C29.9999 35.7138 29.3857 37.1972 28.292 38.291C27.198 39.385 25.7141 40 24.167 40C22.6199 40 21.1359 39.385 20.042 38.291C18.9483 37.1972 18.3341 35.7138 18.334 34.167V5.83301C18.3341 4.2862 18.9483 2.80283 20.042 1.70898C21.1359 0.615042 22.6199 2.17359e-05 24.167 0Z",
		fill: "currentColor"
	})
});
export default SvgVideoPause;
